import * as React from 'react';

const HeaderSeparator = () => (
  <div className="messenger-header-separator">
    <div className="messenger-header-separator__line" />
  </div>
);

export default HeaderSeparator;
